import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    Box,
    Typography
} from "@mui/material";

import { IssuePriority } from "../../API";
import { issuePriorityText } from "../../componentsV2/issue/issuesPriorityText";
type PriorityDetails = {
    // Icon: ElementType<CustomIconProps>;
    icon: JSX.Element;
    text: string;
    color?: any;
};

const PRIORITY_TO_DETAIL_MAP = new Map<IssuePriority, PriorityDetails>(
    [
        [
            IssuePriority.HIGH,
            {
                icon: <KeyboardArrowUpIcon/>,
                text: issuePriorityText[IssuePriority.HIGH],
                color: "#FF0000"
            }
        ],
        [
            IssuePriority.MEDIUM,
            {
                icon: <DragHandleIcon/>,
                text: issuePriorityText[IssuePriority.MEDIUM],
                color: "#cb9d06"
            }
        ],
        [
            IssuePriority.LOW,
            {
                icon: <KeyboardArrowDownIcon/>,
                text: issuePriorityText[IssuePriority.LOW],
                color: "#2ecc40"
            }
        ]
    ]
);

export const IssuePriorityDisplay = ({ priority }: { priority: IssuePriority; }) => {
    const priorityDetails = PRIORITY_TO_DETAIL_MAP.get(priority);

    return (
        <Box display="flex" alignItems="center" gap={1} sx={{ color: priorityDetails?.color }}>
            {priorityDetails?.icon && (
                priorityDetails.icon
            )}
            <Typography color={priorityDetails?.color} fontSize="0.875rem">
                {priorityDetails?.text}
            </Typography>
        </Box>
    );
};